import { defineComponent, h, type PropType } from 'vue';
import type { ConnectScreenDefinition } from './screen';
import { useConnectPresentation } from './usePresentation';

/**
 * Renders a screen's presentation: the one `<app>.presentation` names for the
 * screen, else its default, with the screen's contract as the prop `screen`.
 * The route's component builds the contract and renders this host. The
 * definition is read once — a screen does not change its presentations while
 * it shows.
 */
export const ConnectPresentationHost = defineComponent({
  name: 'ConnectPresentationHost',
  props: {
    definition: {
      type: Object as PropType<ConnectScreenDefinition<unknown>>,
      required: true,
    },
    /** The screen's contract, handed to the presentation as is. */
    screen: { type: null as unknown as PropType<unknown>, required: true },
  },
  setup(props) {
    const state = useConnectPresentation(props.definition);
    return () => {
      const presentation = state.current.value;
      return h(presentation.component, { key: presentation.id, screen: props.screen });
    };
  },
});
